import { render, staticRenderFns } from "./TestComparisonDummy.vue?vue&type=template&id=804b4932&scoped=true&"
import script from "./TestComparisonDummy.vue?vue&type=script&lang=js&"
export * from "./TestComparisonDummy.vue?vue&type=script&lang=js&"
import style0 from "./TestComparisonDummy.vue?vue&type=style&index=0&id=804b4932&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "804b4932",
  null
  
)

export default component.exports